import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { getPaymentCredentialMine, updatePaymentCredentialMine } from "../api";
import { useNotification } from "../../../contexts/NotificationContext";

export const useGetPaymentCredentialMine = () => {
  return useQuery({
    queryKey: ["payment-credential-mine"],
    queryFn: () => getPaymentCredentialMine(),
  });
};

export const useUpdatePaymentCredentialMine = () => {
  const queryClient = useQueryClient();
  const { showNotification } = useNotification();

  return useMutation({
    mutationFn: (data) => updatePaymentCredentialMine(data),
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: ["payment-credential-mine"] });
      showNotification("success", "Payment settings updated successfully!");
    },
    onError: (error) => {
      console.error("Error updating payment settings:", error);
      let errorMessage = "Error updating payment settings. Please try again.";
      if (error?.response?.data?.error?.message) {
        errorMessage = error.response.data.error.message;
      } else if (error?.response?.data?.message) {
        errorMessage = error.response.data.message;
      } else if (error?.message) {
        errorMessage = error.message;
      }
      showNotification("danger", errorMessage);
    },
  });
};
